import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const handIcon: SxStyle = {
  fontSize: (p) => p.typography.body1,
};
